export default "__VITE_ASSET__DxdbFS7I__"